module.exports = __webpack_public_path__ + "img/lock.66674f46.jpg";